module.exports = __webpack_public_path__ + "img/icon_link.959519e9.png";